import { createContext } from "react";
import { useContext } from "react";
import { Range } from "../../types/range";

export type RangeState = {
  range?: Range;
  currentTimeOffset: number;
  adjustedDuration: number;
};

export const RangeContext = createContext<RangeState | undefined>(undefined);

export const useRange = (): RangeState => {
  const range = useContext(RangeContext);
  if (range === undefined) {
    throw new Error("useRange must be used within a RangeContext Provider");
  }

  return range;
};
